module.exports = __webpack_public_path__ + "img/pic1.19a5c7dc.png";